module.exports = __webpack_public_path__ + "static/KIMRGB-66f4b14f2133a80b2f771d755867898b.svg";